import { HANDLE_FOLLOW_UP } from '../actions';
import moment from 'moment';

const initialState = {  
    followup: [],
    startDate: moment().startOf('month').format("YYYY-MM-DD"),
    endDate: moment().endOf('month').format("YYYY-MM-DD"),
    manager: "",
    status: [8],
    pageNo: 1,
    workTypeFilter: [""],
    area: "",
    search: "",
    customer: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case HANDLE_FOLLOW_UP:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  } 
}
